import React from 'react';

/** Esqueleto — lugar do conteúdo enquanto carrega, para a tela não pular. */
export default function Esqueleto({ linhas = 3 }) {
  return (
    <div role="status" aria-label="Carregando">
      {Array.from({ length: linhas }, (_, i) => (
        <div key={i} className="sj-esqueleto sj-esqueleto--linha" />
      ))}
    </div>
  );
}
